import React, { useRef, useEffect } from "react";
import Header from "../extern/HeaderNav/Header";
import Footer from "../../components/extern/Footer/Footer";
import { gsap } from "gsap";

const PublicRouter = ({ children }) => {
  const contentRef = useRef();

  useEffect(() => {
    gsap.from(contentRef.current, {
      duration: 0.6,
      ease: "power2.out",
    });
  }, []);

  return (
    <>
      <Header />
      <div className="public-router-wrapper">
        <div className="public-content" ref={contentRef}>
          {children}
        </div>
        <Footer />
      </div>
    </>
  );
};

export default PublicRouter;
